export default {
    test: 'test',
    devices: [],
    apps: [],
    logs: [],
    terminalOutput: [],
    deviceInformation: {}
}


// WEBPACK FOOTER //
// ./src/store/state.js